import React, { useState } from "react";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";

function Create() {
  const initalState = {
    loading: false,
  };
  const [state, setstate] = useState(initalState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };
  return (
    <CommonFrom
      form={input}
      loading={state.loading}
      header="دسته بندی مقالات"
      textbtn="لیست دسته بندی مقالات"
      linkbtn="/Admin/blogCategory/List"
      btnName="ایجاد دسته بندی مقالات"
      submit={Handler}
    />
  );
}

export default Create;
export const input = [
  {
    label: "عنوان",
    size: "col-md ",
    classNames: "mt-2",
    placeholder: "",
    name: "name",
    value: "",
  },
  {
    label: "توضیحات",
    size: "col-md",
    classNames: "mt-2",
    placeholder: "",
    name: "description",
    value: "",
    type: "text",
  },
  {
    label: "کلمات کلیدی سئو",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoKeyword",
    value: "",
    input: "textarea",
  },
  {
    label: "توضیحات کلیدی سئو",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoDescription",
    value: "",
    input: "textarea",
  },
  {
    label: "آیکون دسته بندی",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "photo",
    input: "file",
    accept: "image/png, image/jpeg",
  },
];
